import { Component, OnInit } from '@angular/core';
import { FormV2ServiceService } from '../form-v2/form-v2-service.service';
import { TranslationEnum } from '../shared/enums/translation-enum';
import { FormDataMulti } from './form-model/FormDataMulti';
import { TresciService } from '../tresci.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { ViewJSONComponent } from '../form-v2/form-control/controls/view-json/view-json.component';
import { TreeTechnologyComponent } from '../module-tree-technology/tree-technology/tree-technology.component';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { UniversalDialogComponent } from '../shared/components/universal-dialog/universal-dialog.component';
import { DialogData } from '../shared/models/dialog/dialog-data.model';

@Component({
  selector: 'app-form-multi',
  templateUrl: './form-multi.component.html',
  styleUrls: ['./form-multi.component.scss']
})
export class FormMultiComponent implements OnInit {
  public TranslationEnum = TranslationEnum;
  FormData:FormDataMulti; 


  constructor(private formService: FormV2ServiceService, public tresci: TresciService,public dialog: MatDialog, public router: Router, private translateService: TranslateService, private activatedRoute: ActivatedRoute) {
    this.FormData = new FormDataMulti(tresci, router, translateService, activatedRoute);
  }

  ngOnInit(): void {

      this.FormData.culture = window['culture'];
      this.FormData.IsTrader = window['isTrader'];

      let dialogRef: MatDialogRef<UniversalDialogComponent, any>;
      const data: DialogData = {
        title: 'info_wycena_masowa',
        content: 'tresc_wycena_masowa',
        answerOk: false,
      };
      dialogRef = this.dialog.open(UniversalDialogComponent, { data: data });
      dialogRef.afterClosed().subscribe((result) => {
        if (result === true) {
          this.GetFirstStep();
          // this.GetStep();
        } else {
          this.router.navigate(['Home']);
        }
      });


      
  }

  GetFirstStep(){
    if(this.FormData.generatePrev){
      this.FormData.header(this.formService);
    } else {
      this.FormData.GetFirstStep(this.formService);
    }
    
  }

 
   drop(event: CdkDragDrop<string[]>, numer) {
      if (event.previousContainer === event.container) {
        moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        this.FormData.ustawModPoz(numer, this.formService);
        // console.log("zmiana poz", event.container.data);
      } else {
        transferArrayItem(event.previousContainer.data,
          event.container.data,
          event.previousIndex,
          event.currentIndex,);
      
        
      }
    }
     otworzDev(dane){
        var dialogRef = this.dialog.open(ViewJSONComponent, {
          maxWidth: Math.round(window.innerWidth * 0.6569),
          // maxHeight: Math.round(window.innerHeight * 0.9595),
          width: '100%',
          // height: '100%',
          disableClose: false,
          data: dane,
        });
      }
      protected showTechnologyValuation() {
          var step = null;
          // console.log("Parametry", this.FormData.ostatnieParametryValuation);
          this.dialog.open(TreeTechnologyComponent, {
            width: '1250px',
            maxWidth: '90%',
            disableClose: true,
            data: {
              FormGroupForResultInfo: this.FormData,
              StepForResultInfo: this.FormData.valuationStep,
              Parameters: this.FormData.ostatnieParametryValuation,
              PreviousPositionParameters: this.FormData.ostatniePrevParametryValuation,
              IsValuation: true,
              ProductPrefix: this.FormData.typ,
              IsTrader: false
            }, 
          });
        }
        
      protected showTechnology() {
      
          // console.log("Parametry", this.FormData.ostatnieParametry, this.FormData.produktPrefix);
          this.dialog.open(TreeTechnologyComponent, {
            width: '1250px',
            maxWidth: '90%',
            disableClose: true,
            data: {
              FormGroupForResultInfo: this.FormData,
              StepForResultInfo: this.FormData.step,
              Parameters: this.FormData.ostatnieParametry,
              PreviousPositionParameters: [],
              IsValuation: false,
              ProductPrefix: "ALL",
              IsTrader: false
            },
          });
        }
        logTMP(){
          // console.log(this.FormData.ParameterExtensions);
        }

}
